import baseAPI from "./api";

export interface OutlookStatus {
  connected: boolean;
  email: string | null;
  connectedAt: string | null;
}

export interface AuthUrlResponse {
  authUrl: string;
}

const getStatus = async (): Promise<OutlookStatus> => {
  const res = await baseAPI.get("/outlook/status");
  return res.data as OutlookStatus;
};

const getAuthUrl = async (): Promise<AuthUrlResponse> => {
  // Pass current URL so the callback can redirect back to the correct origin (with subdomain)
  const returnUrl = encodeURIComponent(window.location.href);
  const res = await baseAPI.get(`/outlook/auth?returnUrl=${returnUrl}`);
  return res.data as AuthUrlResponse;
};

const disconnect = async (): Promise<{ success: boolean; message: string }> => {
  const res = await baseAPI.post("/outlook/disconnect");
  return res.data;
};

export const outlookService = {
  getStatus,
  getAuthUrl,
  disconnect,
};
